<template>
	<div>
		<div class="breadcrumb-box">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<li class="breadcrumb-item back"><a href="#" @click="$router.go(-1)">Back</a></li>
					<li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">NOS</a></li>
					<li class="breadcrumb-item active" aria-current="page">Create NOS</li>
				</ol>
			</nav>
		</div>

		<div class="form-box mt-5">
			<div class="d-flex justify-content-between align-items-center">
				<h2 class="form-box__title">New Criteria</h2>
			</div>
			<div class="mt-3">
				<div class="row mt-3">
					<div class="col-lg-3"><label class="form-label">Pilih Ekspedisi</label></div>
					<div class="col-lg-4">
						<multiselect
							v-model="form.ekspedisi_id"
							:custom-label="opt => ekspedisiOptions.find(x => x.id == opt).name"
							:options="ekspedisiOptions.map(x => x.id)"
							placeholder="Select Ekspedisi"
						></multiselect>
					</div>
				</div>

				<div class="row mt-3">
					<div class="col-lg-3"><label class="form-label">Pilih Criteria</label></div>
					<div class="col-lg-4">
						<multiselect
							v-model="form.nos_id"
							:custom-label="opt => nosOptions.find(x => x.id == opt).nos"
							:options="nosOptions.map(x => x.id)"
							placeholder="Select NOS"
						></multiselect>
					</div>
				</div>

				<div class="d-flex justify-content-end mt-5">
					<button 
						type="button"
						class="btn btn-submit"
						@click="submitForm()">Submit NOS</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
	metaInfo: {
		title: "Create NOS",
	},
	data() {
		let startDate = moment().startOf("month").format("YYYY-MM-DD");
		let currentDate = moment().format("YYYY-MM-DD");

		return {
			ekspedisiOptions: [],
            selectedNos: null, // To store the selected "nos" value
            nosOptions: [],    // To store the options retrieved from the API
			phoneNoError: false,
			selectedNopol: null,
			filter: {
				start: startDate,
				end: currentDate,
			},
			form: {
				ekspedisi_id : null,
				nos_id : null

			},
		};
	},
	components: {
		Multiselect,
	},
	created() {
		// Fetch data from the API
		axios
			.get("/api/master/ekspedisi")
			.then((response) => {
				if (response.data && response.data.data) {
					// Map the API data to match the format expected by vue-multiselect
					this.ekspedisiOptions = response.data.data.map((form) => ({
						id: form.id,
						name: form.name,
					}));
				}
			})
			.catch((error) => {
				console.error("Error fetching ekspedisi data:", error);
			});

        axios
            .get("/api/master/nos")
            .then((response) => {
                if (response.data && response.data.data) {
                // Map the API data to match the format expected by vue-multiselect
                this.nosOptions = response.data.data.map((form) => ({
                    id: form.id,
                    nos: form.nos,
                }));
                }
            })
            .catch((error) => {
                console.error("Error fetching ekspedisi data:", error);
            });
	},
	watch: {
		"form.name"() {
			this.form.name = this.form.name.toUpperCase();
		},
	},
	methods: {
		restrictToNumbers() {
			// Limit the input to 12 characters or less
			if (this.form.phone_no.length > 12) {
				this.form.phone_no = this.form.phone_no.slice(0, 12);
			}
			if (this.form.name.length > 50) {
				this.form.name = this.form.name.slice(0, 50);
			}

			// Remove any non-numeric characters from the input
			this.form.phone_no = this.form.phone_no.replace(/[^0-9]/g, "");
			this.form.ekspedisi = this.form.ekspedisi.replace(/[^0-9]/g, "");
			this.form.ktp_no = this.form.ktp_no.replace(/[^0-9]/g, "");
			this.form.license_no = this.form.license_no.replace(/[^0-9]/g, "");
		},
		restrictToAlphaNumeric() {
			// Get the current input value
			let inputValue = this.form.license_no;

			// Use a regular expression to remove any characters that are not alphanumeric
			inputValue = inputValue.replace(/[^a-zA-Z0-9]/g, "");

			// Update the input value with the cleaned value
			this.form.license_no = inputValue;
		},
		goBack() {
			this.$router.go(-1); // Go back to the previous route
		},
		submitForm() {
			this.$swal
				.fire({
					title: "Konfirmasi Approval",
					text: "Apakah NOS yang Anda buat sudah sesuai?",
					showCancelButton: true,
					confirmButtonColor: "#82B0EF",
					cancelButtonColor: "#B1B1B1",
					confirmButtonText: "Post NOS",
				})
				.then((result) => {
					if (result.value) {
						// Only send the 'id' of the selected ekspedisi
						const requestData = {
							nos : [
								this.form
							]
						}
						console.log(requestData)

						this.$http
							.put("/api/nos-ekspedisi/audit", requestData)
							.then(() => {
								this.$swal.fire({
									title: "Success!",
									icon: "success",
									type: "success",
									text: "Tambah NOS berhasil disimpan",
								});
								this.$router.go(-1); // Go back to the previous route
							})
							.catch((error) => {
								console.error(
									"%cerror DashboardUserUM.vue line:78 ",
									"color: red; display: block; width: 100%;",
									error
								);
								this.$swal.fire({
									title: "Error!",
									icon: "error",
									type: "error",
									text: error.response.data.message,
								});
							});
					}
				});
		},
	},
};
</script>

<style scoped>
.innerBox {
	background-color: white;
	border-radius: 8px;
	box-shadow: 0px 3px 10px #0000000f;
	padding: 20px;
	padding-left: 40px;
}

.chart {
	background-color: white;
	border-radius: 8px;
	box-shadow: 0px 3px 10px #0000000f;
	padding: 20px;
	align-items: center;
}

.elegant--sub-title {
	font-size: 18px;
	font-weight: 500;
	color: #4d4d4d;
}

/* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

.stats--icon {
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
}

.table td,
.table th {
	text-align: center;
}

.news-image-1 img {
	max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
	text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
	text-align: left; /* To position the news-content on the bottom right */
}

.search-container {
	display: flex;
	align-items: center;
}

.dropdown-container {
	flex: 1;
	margin-right: 10px;
}

.searchbar-container {
	flex: 2;
}

.dropdown {
	width: 100%;
}

.searchbar {
	width: 50%;
	padding: 5px;
}
</style>
